export default __webpack_public_path__ + "static/media/robotHand.1ba16c60.png";